<div class="pContent">

    <div class="listedItem">
        <div class="item">
            <strong>{{ "Bank Name" | translate }}</strong>
            <p>{{ paymentResult.extra.bankName }}</p>
        </div>
        <div class="item">
            <strong>{{ "Account Owner" | translate }}</strong>
            <div class="item-info">
                <p class="cursor-copy" ngxClipboard [cbContent]="paymentResult.extra.ownerName" (cbOnSuccess)="alertService.setNotice('Copied', 'success')">{{ paymentResult.extra.ownerName }}</p>
                <img class="cursor-copy" src="assets/img/icon/copy.svg" alt=" name" width="16" height="17" ngxClipboard [cbContent]="paymentResult.extra.ownerName" (cbOnSuccess)="alertService.setNotice('Copied', 'success')" />
            </div>
        </div>
        <div class="item">
            <strong>{{ "Swift Code" | translate }}</strong>
            <div class="item-info">
                <p class="cursor-copy" ngxClipboard [cbContent]="paymentResult.extra.swiftCode" (cbOnSuccess)="alertService.setNotice('Copied', 'success')">{{ paymentResult.extra.swiftCode }} </p>
                <img class="cursor-copy" src="assets/img/icon/copy.svg" alt=" name" width="16" height="17" ngxClipboard [cbContent]="paymentResult.extra.swiftCode" (cbOnSuccess)="alertService.setNotice('Copied', 'success')" />
            </div>
        </div>
        <div class="item">
            <strong>{{ "IBAN" | translate }}</strong>
            <div class="item-info">
                <p class="cursor-copy" ngxClipboard [cbContent]="paymentResult.extra.accountNumber" (cbOnSuccess)="alertService.setNotice('Copied', 'success')">{{ paymentResult.extra.accountNumber }}</p>
                <img class="cursor-copy" src="assets/img/icon/copy.svg" alt=" name" width="16" height="17" ngxClipboard [cbContent]="paymentResult.extra.accountNumber" (cbOnSuccess)="alertService.setNotice('Copied', 'success')" />
            </div>
        </div>
        <div class="item">
            <strong>{{ "Reference Number" | translate }}</strong>
            <div class="item-info">
                <p class="cursor-copy" ngxClipboard [cbContent]="paymentResult.bankReference" (cbOnSuccess)="alertService.setNotice('Copied', 'success')">{{paymentResult.bankReference }}</p>
                <img class="cursor-copy" src="assets/img/icon/copy.svg" alt=" name" width="16" height="17" ngxClipboard [cbContent]="paymentResult.bankReference" (cbOnSuccess)="alertService.setNotice('Copied', 'success')" />
            </div>
        </div>
        <div class="infoText">
            {{ "The 'Reference Number' should be entered in the description field before money transfer / EFT" | translate }}
            <br>
            <br>
            {{ "bank-transfer-payment-description" | translate }}
        </div>
    </div>
</div>

<div class="pButton">
    <div class="stickyAlert warning">
        {{ "Don't forget to enter reference number mentioned above" | translate }}
    </div>
    <button class="btn btn-primary" (click)="backToMerchant()">{{ "Back to Merchant" | translate }}</button>
</div>